export function getOneTrustDataLayer(): string {
  if (typeof window !== "undefined" && window.OnetrustActiveGroups) {
    return window.OnetrustActiveGroups
  }
  return ""
}
